import React, { useEffect, useState, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useGetAllLandingQuery } from '../store/api/userApiSlice';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import BlogCard from '../components/Blog/BlogCard';
import { GoArrowLeft } from "react-icons/go";
import collegePlaceholder from '../assets/images/ftrdClgImgPlaceholder.png';
import './BlogPost.css';
import { generatePublicUrlLocal } from '../config';

const BlogPost = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetAllLandingQuery();
  
  const [blog, setBlog] = useState(null);
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [displayedRelatedCount, setDisplayedRelatedCount] = useState(3);

  // Extract blogs with same logic as BlogPage
  const allBlogs = useMemo(() => {
    if (!data) return [];
    if (Array.isArray(data) && data.length > 0 && Array.isArray(data[0].blog)) {
      return data[0].blog;
    }
    if (Array.isArray(data)) return data;   
    return [];
  }, [data]);

  useEffect(() => {
    if (allBlogs.length > 0) {
      const currentBlog = allBlogs.find(b => (b._id === id || b.id === id));
      setBlog(currentBlog);

      if (currentBlog) {
        // Find related blogs
        const sameCategory = allBlogs.filter(b => 
          b.category === currentBlog.category && (b._id !== id && b.id !== id)
        );

        const others = allBlogs.filter(b => 
          b.category !== currentBlog.category && (b._id !== id && b.id !== id)
        );

        setRelatedBlogs([...sameCategory, ...others]);
      }
    }
    
    window.scrollTo(0, 0);
    setDisplayedRelatedCount(3);
  }, [id, allBlogs]);

  const handleLoadMoreRelated = () => {
    setDisplayedRelatedCount(prev => prev + 3);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-IN', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  if (isLoading || (allBlogs.length > 0 && !blog)) {
    return (
      <div className="blog-post-page">
        <Navbar />
        <div style={{ padding: '100px 0', textAlign: 'center' }}>
          {isLoading ? 'Loading blog details...' : 'Blog post not found.'}
        </div>
        <Footer />
      </div>
    );
  }

  // Fallback if still no blog after loading
  if (!blog) return null;

  const visibleRelatedBlogs = relatedBlogs.slice(0, displayedRelatedCount);

  return (
    <div className="blog-post-page">
      <Navbar />
      
      <div className="blog-post-container">
        <div className="back-link-container">
           <Link to="/blogs" className="back-link">
             <GoArrowLeft /> BACK TO LIST
           </Link>
        </div>

        <div className="blog-post-header">
           <p className="blog-meta-top">
             {blog.readTime || '5 min read'} • {formatDate(blog.createAt || blog.date)}
           </p>
           <h1 className="blog-post-title">{blog.title}</h1>
        </div>

        <div className="blog-post-hero-img-container">
          <img 
            src={generatePublicUrlLocal(blog.image) || collegePlaceholder} 
            alt={blog.title} 
            className="blog-post-hero-img" 
          />
        </div>

        <div 
          className="blog-post-content" 
          dangerouslySetInnerHTML={{ __html: blog.description || blog.content }} 
        />

        <div className="related-posts-section">
          <h3 className="related-posts-title">Other related Posts</h3>
          <div className="related-posts-grid">
            {visibleRelatedBlogs.map(post => (
              <BlogCard 
                key={post._id || post.id} 
                blog={{
                  ...post,
                  id: post._id || post.id,
                  excerpt: post.description || post.content || '',
                  date: post.createdAt || post.date,
                  readTime: '5 min read',
                  image: post.image
                }}
              />
            ))}
          </div>
          
          {displayedRelatedCount < relatedBlogs.length && (
            <div className="load-more-container">
               <button className="load-more-btn" onClick={handleLoadMoreRelated}>LOAD MORE</button>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BlogPost;
